export default "__VITE_ASSET__NOGIz3g6__"